import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import Loading from "../../shared/component/others/Loading";
import DataTable from "../../shared/component/dataTable/DataTable";
import SaleReportColumn from "../../shared/component/dataTable/columns/SaleReportColumn.json";
import {Button} from "reactstrap";
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AdminZXReportService from "../../shared/service/AdminZXReportService";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import '../reports/SaleReportPage.css';
import '../../shared/styles/SettingsPage.css';

export default class AdminSaleReportDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            merchantBranchId: null,
            loading: false
        };
        this.adminZXReportService = new AdminZXReportService();
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="sale-report-page__dialog">
                <AvForm>
                    {this.renderReport()}
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    exportPdf = () => {
        this.refDataTable.exportPdf();
    }

    sendEmail = () => {
        this.refDataTable.sendEmail();
    }

    renderReport() {
        return (
            <div>
                <ModalConfirm header='Warning' ok='OK' onOkClick={this.calculateAgain}
                              onCancelClick={() => this.setState({displayCalculateConfirmDialog: false})}
                              show={this.state.displayCalculateConfirmDialog}
                              message={this.state.noticeResponse}/>

                <div className="sale-report-page__toolbar settings-page__actions settings-page__actions--inline">
                    <Button color="outline-primary" className="settings-page__btn--action" onClick={this.calculate}>
                        <i className="pi pi-refresh" aria-hidden="true"/>
                        <Translate contentKey="entity.action.csv">Calculate Again</Translate>
                    </Button>
                </div>

                <div className="sale-report-page__table-wrap sale-report-page__report-table">
                    <DataTable fields={SaleReportColumn.fields}
                               refresh={false}
                               ref={(elem) => this.refDataTable = elem}
                               objectName={SaleReportColumn.name}
                               rows={100}
                               reportName="Sale Report"
                               paginator={false}
                               dataURL={!GeneralUtils.isNullOrEmpty(this.state.id) ? "reporting/admin/zxreport/" + this.state.id + "/" + this.state.merchantBranchId : null}
                               selectionMode="single"
                               loading={this.state.loading}/>
                </div>

                <div className="sale-report-page__dialog-footer settings-page__actions settings-page__actions--inline">
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--cancel settings-page__btn--close"
                        onClick={() => this.props.closeDisplayDialog()}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    calculate = () => {
        this.setState({
            displayCalculateConfirmDialog: true,
            noticeResponse: "Are you sure to calculate sale report again?",
        });
    }

    calculateAgain = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.id)) {
            this.setState({
                loading: true,
                displayCalculateConfirmDialog: false,
            });
            this.adminZXReportService.calculateAgain(this.state.id)
                .then(() => {
                    this.setState({
                        loading: false,
                    });
                    this.closeDisplayDialog();
                });
        }
    }

    setData = (data) => {
        this.setState({
            id: data.id,
            merchantBranchId: data.merchantBranchId,
        }, () => {
            this.refDataTable.refresh(data.id, data.merchantBranchId);
        });
    }

    closeDisplayDialog = () => {
        this.props.closeDisplayDialog();
    }
}
